<template>
  <div>
    <WdsButton
      primary
      data-test="add-recruiter-candidate-button"
      @click="() => toggleShowCreateRecruiterFreelancerModal(true)"
    >
      {{ $t('Add Candidate') }}
    </WdsButton>

    <Teleport to="#modals">
      <RecruiterFreelancerModal
        :show="showCreateRecruiterFreelancerModal"
        :on-cancel="() => toggleShowCreateRecruiterFreelancerModal(false)"
        :on-confirm="onConfirm"
        :currency="currency"
        :rate-required="rateRequired"
        :title="$t('Add Candidate')"
        :save-button-text="$t('Add')"
        :save-button-text-while-working="$t('Adding')"
        :help-text="
          !managesWorkers
            ? $t('The candidate will not be contacted before they have been selected for a job.')
            : null
        "
        :manages-workers="managesWorkers"
      />
    </Teleport>
  </div>
</template>

<script setup lang="ts">
import { WdsButton } from '@worksome/wds-components'
import { useMutation } from '@vue/apollo-composable'
import { computed, ref } from 'vue'
import RecruiterFreelancerModal from '@/components/Contacts/RecruiterFreelancer/RecruiterFreelancerModal.vue'
import { CreateRecruiterCandidateMutation } from '@/components/Contacts/RecruiterFreelancer/graphql/mutations'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import { MarketCode } from '@/gql/graphql'

const { mutate: mutateAddCandidate } = useMutation(CreateRecruiterCandidateMutation, {
  clientId: 'publicApi',
  refetchQueries: ['recruiterCandidates'],
})

const props = defineProps<{
  currency: string
  managesWorkers: boolean
}>()

const showCreateRecruiterFreelancerModal = ref(false)
const rateRequired = computed(() => currentAccount.market?.toUpperCase() === MarketCode.Nl)

async function onConfirm(data) {
  await mutateAddCandidate({
    input: {
      recruiter: currentAccount.globalId,
      currency: props.currency,
      ...data,
    },
  })
}
const toggleShowCreateRecruiterFreelancerModal = (value) => {
  showCreateRecruiterFreelancerModal.value = value
}
</script>
